import React, { useState, useEffect } from "react";
import moment from "moment-timezone";
import { putLote as modifLote } from "../helpers/rutaLotes";
import { Modal, Button } from "react-bootstrap";
import 'animate.css';

const ModalFormLote = ({ lote, handleClose, show }) => {
  const [formValues, setFormValues] = useState({
    codlote: "",
    lote: "",
    // montoInicial: "",
    // saldoActual: "",
  });

  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (lote && lote._id) {
      setFormValues({
        codlote: lote.codlote || "",
        lote: lote.lote || "",
      });
    }
  }, [lote]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedValues = {
      ...formValues,
      [name]: value,
    };

    // sincronizamos saldoActual si se cambia montoInicial
    // if (name === "montoInicial") {
    //   updatedValues.saldoActual = value;
    // }

    setFormValues(updatedValues);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const loteModificada = {
      ...formValues,
      saldoActual: formValues.montoInicial,
    };

    try {
      const resp = await modifLote(lote._id, loteModificada);
      console.log("✅ Lote actualizado:", resp);

      setShowSuccess(true); // Mostrar modal éxito

      setTimeout(() => {
        setShowSuccess(false); // Ocultar el modal
        handleClose(); // Luego cerrar el modal principal
      }, 2000);
    } catch (err) {
      console.error("❌ Error al guardar:", err);
      // Si querés, podés mostrar un modal de error también
    }
  };


  return (
    <>
    <Modal show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Modificar Lote</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* <div className="form-group mt-2">
            <label>Fecha</label>
            <input
              type="datetime-local"
              className="form-control"
              name="fecha"
              required
              value={formValues.fecha}
              onChange={handleChange}
            />
          </div> */}

          <div className="form-group mt-2">
            <label>Lote</label>
            <input
              type="text"
              className="form-control"
              name="lote"
              required
              value={formValues.lote}
              onChange={handleChange}
            />
          </div>

        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button type="submit" variant="dark">
            Guardar
          </Button>
        </Modal.Footer>
      </form>
    </Modal>

    <Modal
      show={showSuccess}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="animate__animated animate__fadeInDown"
    >
      <Modal.Body className="text-center">
        <div style={{ fontSize: "3rem" }}>🖐</div>
        <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
      </Modal.Body>
    </Modal>
    </>
  );
};

export default ModalFormLote;
